<div [hidden]="showEditItinerary">
  <div class="pageheader">
    <div class="page-title">
      <h1>Document configurations</h1>
      <div class="btn-group">
        <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
        <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Document configurations log'">
          <app-change-log-link-entity type="DocumentConfig"></app-change-log-link-entity>
        </app-change-log-link>
      </div>
    </div>
  </div>

  <dx-data-grid biz-grid
    [selection]='{ mode: "none" }'
    [dataSource]='configs'
    [bizSetColumnChooser]="true"
    [bizSetAllowColumnReordering]="false"
    [bizSetPager]="false"
    (onInitNewRow)="onInitNewRow($event)"
    (onRowInserting)="onRowInserting($event)"
    (onRowUpdating)="onRowUpdating($event)"
    (onRowRemoving)="onRowRemoving($event)"
    (onEditCanceled)="onEditCanceled($event)"
    (onEditorPreparing)="onEditorPreparing($event)"
    [bizEditRowOnDoubleClick]="true">

    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

    <dxo-editing mode="popup" [allowUpdating]="allowUpdating" [allowAdding]="allowAdding" [allowDeleting]="allowDeleting">
      <dxo-popup title="Document configuration" [showTitle]="true"></dxo-popup>
    </dxo-editing>

    <dxi-column dataField="DistributionObjectId" sortOrder="asc" [calculateSortValue]="getDocumentTypeName" caption="Document type" editCellTemplate="distroDropDown">
      <dxo-lookup [dataSource]="distros" valueExpr="Id" displayExpr="Name"></dxo-lookup>
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxo-header-filter [dataSource]="bizGridFiltervalues.getDocumentTypeFilterData(bizGridFiltervalues.getPropertyValues(this.configs, 'DistributionObjectId'), distros)"/>
    </dxi-column>

    <dxi-column dataField="Direction">
      <dxo-lookup [dataSource]="directions" valueExpr="DirectionId" displayExpr="DirectionName"></dxo-lookup>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="FormatId" caption="Format" [calculateSortValue]="getFormatName">
      <dxo-lookup [dataSource]="formats" valueExpr="FormatsId" displayExpr="FormatName"></dxo-lookup>
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxo-header-filter [dataSource]="bizGridFiltervalues.getFormatFilterData(bizGridFiltervalues.getPropertyValues(this.configs, 'FormatId'), formats)"/>
    </dxi-column>

    <dxi-column dataField="VariantId" caption="Variant" [calculateSortValue]="getVariantName">
      <dxo-lookup [dataSource]="variants" valueExpr="VariantsId" displayExpr="VariantName"></dxo-lookup>
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxo-header-filter [dataSource]="bizGridFiltervalues.getVariantFilterData(bizGridFiltervalues.getPropertyValues(this.configs, 'VariantId'), variants)"/>
    </dxi-column>


    <dxi-column dataField="VariantVersionsId" caption="Version" [calculateSortValue]="getVersionName">
      <dxo-lookup [dataSource]="versions" valueExpr="VariantVersionsId" displayExpr="VariantVersionName">
      </dxo-lookup>
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxo-header-filter [dataSource]="bizGridFiltervalues.getVersionFilterData(bizGridFiltervalues.getPropertyValues(this.configs, 'VariantVersionsId'), versions)"/>
    </dxi-column>

    <dxi-column dataField="Description" caption="Description" dataType="string" [allowGrouping]="false">
    </dxi-column>

    <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.configs, 'CreatedBy'))"></dxo-header-filter></dxi-column>
    <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
    <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="true"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.configs, 'UpdatedBy'))"></dxo-header-filter>   </dxi-column>
    <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

    <dxi-column type="buttons" alignment="right">
      <dxi-button text="Batching"
        hint="Edit Batching Options"
        [onClick]="configureBatchingTypes"
        [visible]="isRowDocumentConfigOut">
      </dxi-button>
      <dxi-button text="Itinerary"
        hint="Edit Itinerary"
        [onClick]="editItinerary">
      </dxi-button>
      <dxi-button name="edit"></dxi-button>
      <dxi-button name="delete"></dxi-button>
      <dxi-button text="Copy"
        [onClick]="onRowCopying"
        [visible]="allowCopying">
      </dxi-button>
      <dxi-button text="Show Log"
        template="logTemplate"
        [visible]="allowShowLog">
      </dxi-button>
    </dxi-column>

    <div *dxTemplate="let cellInfo of 'distroDropDown'">
      <dx-drop-down-box [dropDownOptions]="dropDownOptions" [dataSource]="distros" [(value)]="cellInfo.value"
        displayExpr="Name" valueExpr="Id" contentTemplate="contentTemplate" [disabled]="!getIsNew()">
        <div *dxTemplate="let e of 'contentTemplate'">
          <dx-data-grid [dataSource]="distros" [remoteOperations]="true" [height]="250"
            [selectedRowKeys]="[cellInfo.value]" [focusedRowEnabled]="true" [focusedRowKey]="cellInfo.value"
            [hoverStateEnabled]="true" keyExpr="Id"
            (onSelectionChanged)="onSelectionChanged($event.selectedRowKeys, cellInfo, e.component)">
            <dxi-column dataField="Name"></dxi-column>
            <dxi-column dataField="Description"></dxi-column>
            <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
            <dxo-scrolling mode="virtual"></dxo-scrolling>
            <dxo-selection mode="single"></dxo-selection>
          </dx-data-grid>
        </div>
      </dx-drop-down-box>
    </div>

    <ng-container *dxTemplate="let cell of 'logTemplate'">
      <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log'" [showIcon]="false" classNames="dx-link">
        <app-change-log-link-entity type="DocumentConfig" [id]="cell.data.DocumentConfigId"></app-change-log-link-entity>
      </app-change-log-link>
    </ng-container>

  </dx-data-grid>
</div>

@if (showEditItinerary) {
  <div>
    <div class="pageheader">
      <div class="page-title">
        <h1>{{ currentEditingItineraryName }}</h1>
      </div>
    </div>
    <app-developer-document-configs-itinerary [documentConfigId]="currentEditingItineraryDocumentConfigId" (cancelled)="showEditItinerary=false"></app-developer-document-configs-itinerary>
  </div>
}
